package one.healthium.update_food_preferences.ui

import one.healthium.ui.components.question.AnswerStatus
import one.healthium.ui.components.question.AnswerUiModel
import one.healthium.ui.components.question.QuestionUiModel
import one.healthium.update_food_preferences.domain.models.FoodPreferenceStatus
import one.healthium.update_food_preferences.domain.models.FoodPreferencesCategoryModel

internal data class UpdateFoodPreferencesUiState(
    val loading: Boolean = false,
    val foodPreferences: List<FoodPreferencesCategoryModel>? = null,
    val saveInProgress: Boolean = false,
    val selectedAnswers: Map<String, List<Pair<AnswerUiModel, AnswerStatus>>?> = emptyMap(),
) {
    val uiData: List<QuestionUiModel>? = foodPreferences?.map { foodPreferenceCategory ->
        val selectedAnswers = selectedAnswers[foodPreferenceCategory.id].orEmpty()

        QuestionUiModel(
            id = foodPreferenceCategory.id,
            kind = null,
            question = foodPreferenceCategory.description,
            allowedStatuses = foodPreferenceCategory.availableStatuses.map { it.toAnswerStatus() },
            answers = foodPreferenceCategory.options
                .map { answer ->
                    AnswerUiModel(
                        id = answer.id,
                        text = answer.text,
                        status = selectedAnswers.firstOrNull { it.first.id == answer.id }?.second
                            ?: answer.status.toAnswerStatus(),
                    )
                }
                .sortedBy { it.text },
        )
    }
}

private fun FoodPreferenceStatus.toAnswerStatus(): AnswerStatus {
    return when (this) {
        FoodPreferenceStatus.Included -> AnswerStatus.Included
        FoodPreferenceStatus.Excluded -> AnswerStatus.Excluded
        FoodPreferenceStatus.Neutral -> AnswerStatus.None
    }
}
